import { Option } from "./option";
import { Root } from "./root";

export const PillSelector = { Root, Option };
